import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/logo.png'


const _hoisted_1 = {
  class: "grid",
  style: {"min-height":"100%"}
}
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "pr-2" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Trường Đại học Giao thông vận tải",
    src: _imports_0,
    class: "max-w-full"
  })
], -1)
const _hoisted_4 = { class: "flex flex-column gap-2 sm:w-full md:w-6" }
const _hoisted_5 = {
  id: "code",
  class: "p-error"
}
const _hoisted_6 = {
  id: "password",
  class: "p-error"
}
const _hoisted_7 = {
  key: 0,
  class: "p-error pt-1"
}
const _hoisted_8 = {
  key: 0,
  class: "card flex justify-content-center"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "flex flex-row justify-content-end flex-wrap" }
const _hoisted_11 = { class: "flex flex-column" }
const _hoisted_12 = { class: "p-error" }

import { ref } from "vue";
import Button from "primevue/button";
import Card from "primevue/card";
import { Form, Field } from 'vee-validate';
import InputText from 'primevue/inputtext';
import { schema } from '@/validations/tracuu.model'
import axios, { AxiosError } from "axios";
import { MethodResult } from "@/models/MethodResult.model";
import { Nullable } from "primevue/ts-helpers";
import ThongTinXetTuyen from '@/components/ThongTinXetTuyen.vue';
import ProgressSpinner from 'primevue/progressspinner';

const __default__ = {
    name: "TraCuuHoSo",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const loading = ref(false);
const formValue = ref<any>({
    code: null,
    password: null
});
const messages = ref<string | null>(null);
const registration = ref<any>();
const notFoundMessage = ref<Nullable<string>>(null);
const traCuu = async (values: any, actions: any) => {
    loading.value = true;
    notFoundMessage.value = null
    await axios.get<MethodResult<any>>(`/registration/tra-cuu-ho-so?code=${values.code}&password=${values.password}`).then(res => {
        const response = res.data;
        if (response.data && response.data.id !== '00000000-0000-0000-0000-000000000000') {
            registration.value = response.data;
        } else {
            notFoundMessage.value = `Mật khẩu tra cứu không đúng, hoặc Mã hồ sơ hoặc Căn cước công dân chưa đăng ký.`
        }
    }).catch((err: AxiosError) => {
        if (err.status == 400) {
            notFoundMessage.value = 'Dữ liệu không hợp lệ vui lòng kiểm tra lại';
        } else {
            notFoundMessage.value = 'Máy chủ đang bận vui lòng thử lại sau.';

        }
    }).finally(() => {
        loading.value = false;
    });
}
const download = async (registration: any) => {
    if (registration && registration.accessToken) {
        const accessToken = registration.accessToken;
        if (accessToken.token) {
            const url = `/registration/${accessToken.token}.docx`;
            window.location.href = url;
        } else {
            messages.value = 'Có lỗi xảy ra vui lòng thử lại sau';
        }
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Card), { class: "form-container" }, {
        header: _withCtx(() => [
          _hoisted_3
        ]),
        title: _withCtx(() => [
          _createTextVNode(" TRA CỨU HỒ SƠ ĐĂNG KÝ XÉT TUYỂN ĐẠI HỌC CHÍNH QUY ")
        ]),
        subtitle: _withCtx(() => [
          _createVNode(_unref(Form), {
            "initial-values": formValue.value,
            "validation-schema": _unref(schema),
            onSubmit: traCuu
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_unref(Field), {
                  name: "code",
                  "model-value": formValue.value.code
                }, {
                  default: _withCtx(({ field, errorMessage }) => [
                    _createVNode(_unref(InputText), {
                      id: "code",
                      modelValue: formValue.value.code,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formValue.value.code) = $event)),
                      type: "text",
                      placeholder: "Nhập mã hồ sơ hoặc căn cước công dân để tra cứu",
                      class: _normalizeClass({ 'p-invalid': errorMessage, 'w-full': true }),
                      "aria-describedby": "code-help"
                    }, null, 8, ["modelValue", "class"]),
                    _createElementVNode("small", _hoisted_5, _toDisplayString(errorMessage), 1)
                  ]),
                  _: 1
                }, 8, ["model-value"]),
                _createVNode(_unref(Field), {
                  name: "password",
                  "model-value": formValue.value.password
                }, {
                  default: _withCtx(({ field, errorMessage }) => [
                    _createVNode(_unref(InputText), {
                      id: "password",
                      modelValue: formValue.value.password,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formValue.value.password) = $event)),
                      type: "password",
                      placeholder: "Mật khẩu tra cứu thông tin hồ sơ",
                      class: _normalizeClass({ 'p-invalid': errorMessage }),
                      "aria-describedby": "password-help"
                    }, null, 8, ["modelValue", "class"]),
                    _createElementVNode("small", _hoisted_6, _toDisplayString(errorMessage), 1)
                  ]),
                  _: 1
                }, 8, ["model-value"]),
                _createVNode(_unref(Button), {
                  label: "Tra cứu",
                  type: "submit",
                  icon: "pi pi-check",
                  class: "sm:w-full md:w-4",
                  loading: loading.value
                }, null, 8, ["loading"])
              ]),
              (notFoundMessage.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(notFoundMessage.value), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["initial-values", "validation-schema"])
        ]),
        content: _withCtx(() => [
          (loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_unref(ProgressSpinner))
              ]))
            : _createCommentVNode("", true),
          (registration.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", null, [
                      _createVNode(_unref(Button), {
                        type: "button",
                        label: "Tải phiếu đăng ký xét tuyển",
                        icon: "pi pi-download",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (download(registration.value))),
                        outlined: ""
                      })
                    ]),
                    _createElementVNode("div", _hoisted_12, _toDisplayString(messages.value), 1)
                  ])
                ]),
                _createVNode(ThongTinXetTuyen, { registration: registration.value }, null, 8, ["registration"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})